import styled from 'styled-components'
import { colors, fontSizes } from '@sabavision/dio'

const Row = styled.div<any>`
  display: flex;
  gap: ${(props) => props.gap};
  &.space-between {
    justify-content: space-between;
  }
  &.actions {
    button {
      height: 32px !important;
    }
  }
`
export { Row }

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-family: 'IRANSans';
  padding: 8px 20px 20px;
  width: inherit;
`
export { Column }

const ClickableIcon = styled.span`
  cursor: pointer;
  color: ${colors.oceanGreen};
`
export { ClickableIcon }

const Label = styled.span`
  font-family: 'IRANSans';
  font-style: normal;
  font-weight: 400;
  font-size: ${fontSizes.m1};
  line-height: 24px;
  color: ${colors.graniteGray};
`
export { Label }

const State = styled.span`
  font-family: IRANSans;
  font-style: normal;
  font-weight: 400;
  font-size: ${fontSizes.m1};
  line-height: 24px;
  color: ${colors.spanishGray};
  padding-inline-start: 5px;
`
export { State }

const EditWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-family: 'IRANSans';
  width: inherit;
  padding: 22px 27px;

  .otp-container {
    padding-inline: 30px;
    input {
      width: 30px !important;
      height: 35px !important;
    }
  }
`
export { EditWrapper }

const CompleteProfileMessage = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: ${fontSizes.s2};
  line-height: 20px;
  text-align: right;
  color: ${colors.graniteGray};
  .link {
    color: ${colors.blueJeans};
    text-decoration: underline;
  }
`
export { CompleteProfileMessage }
